module.exports = __webpack_public_path__ + "static/media/ResumenINGRESOS.43f74295.svg";